// extracted by mini-css-extract-plugin
export default {"ModelContainer":"image-translation_ModelContainer__Qt3JJ","CameraModalContainer":"image-translation_CameraModalContainer__Y4rpH","modalHeight":"image-translation_modalHeight__xZI8E"};